import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  updateInstructorSelection(event) {
    // The instructor selector widget automatically updates the hidden field
    // This method is called when an instructor is selected
    // We can add any additional logic here if needed
  }
}

